import { RuntimeException1r3t0zl97011n as RuntimeException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloExceptionClass;
function ApolloException() {
  if (ApolloExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.new_kotlin_RuntimeException_iani9z_k$(message, cause);
        captureStack($this, $this.$throwableCtor_3);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloException');
    ApolloExceptionClass = $;
  }
  return ApolloExceptionClass;
}
var ApolloOfflineExceptionClass;
function ApolloOfflineException() {
  if (ApolloOfflineExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor() {
        return new.target.new_com_apollographql_apollo_exception_ApolloOfflineException_mr6sjr_k$();
      }
      static new_com_apollographql_apollo_exception_ApolloOfflineException_mr6sjr_k$() {
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$('The device is offline');
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloOfflineException', $.new_com_apollographql_apollo_exception_ApolloOfflineException_mr6sjr_k$);
    ApolloOfflineExceptionClass = $;
  }
  return ApolloOfflineExceptionClass;
}
var ApolloNetworkExceptionClass;
function ApolloNetworkException() {
  if (ApolloNetworkExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message, platformCause) {
        return new.target.new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$(message, platformCause);
      }
      static new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$(message, platformCause) {
        message = message === VOID ? null : message;
        platformCause = platformCause === VOID ? null : platformCause;
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$(message, platformCause instanceof Error ? platformCause : null);
        captureStack($this, $this.$throwableCtor_4);
        $this.platformCause_1 = platformCause;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloNetworkException', $.new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$);
    ApolloNetworkExceptionClass = $;
  }
  return ApolloNetworkExceptionClass;
}
var ApolloWebSocketClosedExceptionClass;
function ApolloWebSocketClosedException() {
  if (ApolloWebSocketClosedExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(code, reason, cause) {
        return new.target.new_com_apollographql_apollo_exception_ApolloWebSocketClosedException_flboe8_k$(code, reason, cause);
      }
      static new_com_apollographql_apollo_exception_ApolloWebSocketClosedException_flboe8_k$(code, reason, cause) {
        reason = reason === VOID ? null : reason;
        cause = cause === VOID ? null : cause;
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$("WebSocket Closed code='" + code + "' reason='" + reason + "'", cause);
        captureStack($this, $this.$throwableCtor_4);
        $this.code_1 = code;
        $this.reason_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloWebSocketClosedException');
    ApolloWebSocketClosedExceptionClass = $;
  }
  return ApolloWebSocketClosedExceptionClass;
}
var ApolloGraphQLExceptionClass;
function ApolloGraphQLException() {
  if (ApolloGraphQLExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(error) {
        return new.target.new_com_apollographql_apollo_exception_ApolloGraphQLException_ytcmdd_k$(error);
      }
      static new_com_apollographql_apollo_exception_ApolloGraphQLException_ytcmdd_k$(error) {
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$("GraphQL error: '" + error.message_1 + "'");
        captureStack($this, $this.$throwableCtor_4);
        $this.error_1 = error;
        $this.errors_1 = listOf($this.error_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloGraphQLException');
    ApolloGraphQLExceptionClass = $;
  }
  return ApolloGraphQLExceptionClass;
}
var DefaultApolloExceptionClass;
function DefaultApolloException() {
  if (DefaultApolloExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message, cause) {
        return new.target.new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$(message, cause);
      }
      static new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$(message, cause);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'DefaultApolloException', $.new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$);
    DefaultApolloExceptionClass = $;
  }
  return DefaultApolloExceptionClass;
}
var NoDataExceptionClass;
function NoDataException() {
  if (NoDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(cause) {
        return new.target.new_com_apollographql_apollo_exception_NoDataException_waozn4_k$(cause);
      }
      static new_com_apollographql_apollo_exception_NoDataException_waozn4_k$(cause) {
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$('No data was found', cause);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'NoDataException');
    NoDataExceptionClass = $;
  }
  return NoDataExceptionClass;
}
var JsonDataExceptionClass;
function JsonDataException() {
  if (JsonDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message) {
        return new.target.new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$(message);
      }
      static new_com_apollographql_apollo_exception_JsonDataException_fxccxn_k$(message) {
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$(message);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDataException');
    JsonDataExceptionClass = $;
  }
  return JsonDataExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(message) {
        return new.target.new_com_apollographql_apollo_exception_JsonEncodingException_k2lmxo_k$(message);
      }
      static new_com_apollographql_apollo_exception_JsonEncodingException_k2lmxo_k$(message) {
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$(message);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
var ApolloHttpExceptionClass;
function ApolloHttpException() {
  if (ApolloHttpExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(statusCode, headers, body, message, cause) {
        return new.target.new_com_apollographql_apollo_exception_ApolloHttpException_vl9kqq_k$(statusCode, headers, body, message, cause);
      }
      static new_com_apollographql_apollo_exception_ApolloHttpException_vl9kqq_k$(statusCode, headers, body, message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$(message, cause);
        captureStack($this, $this.$throwableCtor_4);
        $this.statusCode_1 = statusCode;
        $this.headers_1 = headers;
        $this.body_1 = body;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloHttpException');
    ApolloHttpExceptionClass = $;
  }
  return ApolloHttpExceptionClass;
}
var RouterErrorClass;
function RouterError() {
  if (RouterErrorClass === VOID) {
    class $ extends ApolloException() {
      constructor(errors) {
        return new.target.new_com_apollographql_apollo_exception_RouterError_4vl01r_k$(errors);
      }
      static new_com_apollographql_apollo_exception_RouterError_4vl01r_k$(errors) {
        var tmp0_safe_receiver = firstOrNull(errors);
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$("Router error(s) (first: '" + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.message_1) + "')");
        captureStack($this, $this.$throwableCtor_4);
        $this.errors_1 = errors;
        return $this;
      }
    }
    initMetadataForClass($, 'RouterError');
    RouterErrorClass = $;
  }
  return RouterErrorClass;
}
var SubscriptionOperationExceptionClass;
function SubscriptionOperationException() {
  if (SubscriptionOperationExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(operationName, payload) {
        return new.target.new_com_apollographql_apollo_exception_SubscriptionOperationException_du4zxk_k$(operationName, payload);
      }
      static new_com_apollographql_apollo_exception_SubscriptionOperationException_du4zxk_k$(operationName, payload) {
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$('Operation error ' + operationName);
        captureStack($this, $this.$throwableCtor_4);
        $this.payload_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionOperationException');
    SubscriptionOperationExceptionClass = $;
  }
  return SubscriptionOperationExceptionClass;
}
var SubscriptionConnectionExceptionClass;
function SubscriptionConnectionException() {
  if (SubscriptionConnectionExceptionClass === VOID) {
    class $ extends ApolloException() {
      constructor(payload) {
        return new.target.new_com_apollographql_apollo_exception_SubscriptionConnectionException_wtl9g7_k$(payload);
      }
      static new_com_apollographql_apollo_exception_SubscriptionConnectionException_wtl9g7_k$(payload) {
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$('Subscription connection error');
        captureStack($this, $this.$throwableCtor_4);
        $this.payload_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionConnectionException');
    SubscriptionConnectionExceptionClass = $;
  }
  return SubscriptionConnectionExceptionClass;
}
var NullOrMissingFieldClass;
function NullOrMissingField() {
  if (NullOrMissingFieldClass === VOID) {
    class $ extends ApolloException() {
      constructor(message) {
        return new.target.new_com_apollographql_apollo_exception_NullOrMissingField_iji73y_k$(message);
      }
      static new_com_apollographql_apollo_exception_NullOrMissingField_iji73y_k$(message) {
        var $this = this.new_com_apollographql_apollo_exception_ApolloException_vuizhv_k$(message);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'NullOrMissingField');
    NullOrMissingFieldClass = $;
  }
  return NullOrMissingFieldClass;
}
//region block: exports
export {
  ApolloException as ApolloException16lek20l78zc3,
  ApolloGraphQLException as ApolloGraphQLException2qazyzs4ebcad,
  ApolloHttpException as ApolloHttpException3o30u8ntkffuh,
  ApolloNetworkException as ApolloNetworkException3denf70pfh242,
  ApolloOfflineException as ApolloOfflineException3onq1f2zlyouj,
  ApolloWebSocketClosedException as ApolloWebSocketClosedException26hvn543pf46i,
  DefaultApolloException as DefaultApolloException8w3ielfxng0h,
  JsonDataException as JsonDataException2rdtm884tky1l,
  JsonEncodingException as JsonEncodingException1gbe1fu68vssf,
  NoDataException as NoDataException34qvcinicy2ih,
  NullOrMissingField as NullOrMissingField1bkks6typ2v8h,
  RouterError as RouterError3i6hxcnqsy5l3,
  SubscriptionConnectionException as SubscriptionConnectionException12fjxvnnqzby5,
  SubscriptionOperationException as SubscriptionOperationException3t8cqqpx8bt9j,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
